export enum LibPhoneNumberErrorType {
  TooShort = 'TOO_SHORT',
  TooLong = 'TOO_LONG',
  InvalidCountry = 'INVALID_COUNTRY',
  NotANumber = 'NOT_A_NUMBER',
  NotValid = 'NOT_VALID',
}
